/* global Util */
import FontFaceObserver from 'fontfaceobserver';
import { getBodyElement } from '@/js/utils/dom';
import { setCookie, getCookie, FONTS_LOADED_NAME, FONTS_LOADED_VALUE } from '@/js/utils/cookie';

(() => {
  return Promise.all([
    new FontFaceObserver('Playfair Display', { weight: 400 }).load(),
    new FontFaceObserver('Taviraj', { weight: 400 }).load(),
  ])
    .then(() => {
      const bodyElm = getBodyElement();
      bodyElm.dispatchEvent(new CustomEvent('fonts-loaded'));

      if (!Util.hasClass(bodyElm, 'fonts-loaded')) {
        Util.addClass(bodyElm, 'fonts-loaded');
      }

      if (getCookie(FONTS_LOADED_NAME) !== FONTS_LOADED_VALUE) {
        setCookie(FONTS_LOADED_NAME, FONTS_LOADED_VALUE);
      }
    })
    .catch(error => {
      console.warn(error); // eslint-disable-line no-console
      setCookie(FONTS_LOADED_NAME, 'no');
    });
})();
